module.exports = __webpack_public_path__ + "static/media/bursts_03.8a4cbb3d.svg";